import { weddingConfig } from '@/data/weddingConfig';
import MusicToggle from '@/components/feature/MusicToggle';
import Hero from './components/Hero';
import Introduction from './components/Introduction';
import DateSection from './components/DateSection';
import Countdown from './components/Countdown';
import Ceremony from './components/Ceremony';
import Reception from './components/Reception';
import PhotoDivider from './components/PhotoDivider';
import OurStory from './components/OurStory';
import Gallery from './components/Gallery';
import DressCode from './components/DressCode';
import ImportantInfo from './components/ImportantInfo';
import GiftRegistry from './components/GiftRegistry';
import Accommodation from './components/Accommodation';
import RSVP from './components/RSVP';
import FinalPhoto from './components/FinalPhoto';
import Footer from './components/Footer';

export default function Home() {
  const {
    showOurStory,
    showGallery,
    showDressCode,
    showImportantInformation,
    showGiftRegistry,
    showAccommodation,
  } = weddingConfig;

  return (
    <main className="min-h-screen w-full bg-background-50">
      <Hero />
      <Introduction />
      <DateSection />
      <Countdown />
      <Ceremony />
      <Reception />
      <PhotoDivider />
      {showOurStory && <OurStory />}
      {showGallery && <Gallery />}
      {showDressCode && <DressCode />}
      {showImportantInformation && <ImportantInfo />}
      {showGiftRegistry && <GiftRegistry />}
      {showAccommodation && <Accommodation />}
      <RSVP />
      <FinalPhoto />
      <Footer />
      <MusicToggle />
    </main>
  );
}